<template>
  <section v-if="display || (partners && partners.length)" id="partners" :class="{ 'partners--display': display }">
    <ul class="partners">
      <li v-for="(partner, i) in partners" :key="i">
        <a v-if="!display" :href="partner.hrefUrl" :title="partner.altText" rel="noopener noreferrer" target="_blank">
          <img :src="partner.imgUrl" :alt="partner.altText" />
        </a>
        <img v-else :src="partner.imgUrl" :alt="partner.altText" />
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "Partners",
  props: {
    partners: Array,
    display: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.partners {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background-color: white;

  li {
    max-width: 11.5rem;
    height: 3rem;
    padding: 0 0.75rem;
    margin: 0.25rem auto;
  }

  img {
    height: 100%;
    object-fit: contain;
  }

  a {
    transition: opacity 250ms;

    &:hover {
      opacity: 0.85;
    }
  }
}

#partners.partners--display {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  background-color: white;

  .partners {
    padding: 0;
    background: transparent;
    gap: 0.25rem;

    li {
      height: 2rem;
      max-width: none;
      padding: 0 0.25rem;
    }
  }
}
</style>
